export { Landing as default } from '@ui/views/Landing';
